import { Container } from "./styles";
import Ithish from "../../assets/ithishhh.png";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
// import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import tailiwind from "../../assets/tailiwind.png";
import material from "../../assets/material_ui.png";
import typescriptIcon from "../../assets/typescript-icon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          {/* <p>
            Hi there! I'm Ithish Gudigar, an enthusiastic Software Engineer
            skilled in web development,developing reusable UI components,
            integrating APIs, and delivering userfriendly solutions with clean
            and efficient code.
          </p> */}
          <p>
            Hi there! I'm Ithish Gudigar, a results-driven Software Engineer
            with a strong passion for web development. I specialize in building
            reusable, scalable UI components, integrating RESTful APIs, and
            crafting clean, efficient, and maintainable code that delivers
            seamless user experiences.
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
            Ability to work independently and collaboratively in a team
            environment.{" "}
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education">
            <h3>Education:</h3>
            <h4> Bachelor of Computer Applications (BCA)</h4>
            <p>
              (Mangalore University)
              <br />
              Govt First Grade College Thenkanidiyur, Udupi | 2022
            </p>
            <p>Graduated with 76.83%</p>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education" style={{ marginTop: "10px" }}>
            <h4> Pre - University College (PUC)</h4>
            <p>
              (Department of Pre- University Education , Banglore)
              <br />
              Jnanaganga PU College - Nellikatte | 2019
            </p>
            <p>Graduated with 85.33%</p>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={400}>
          <div className="education" style={{ marginTop: "10px" }}>
            <h4> SSLC</h4>
            <p>
              (Karnataka Secondary Education Examination Board, Banglore)
              <br />
              Govt High School Indhiranagar - Udupi | 2017
            </p>
            <p>Graduated with 78.72%</p>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={500}>
          <div className="experience">
            <h3>Experience:</h3>
            <h4>Software Developer</h4>
            <p>vsoftinfoware | June 2023 - Present</p>
            <p>Udupi, India</p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
              <img src={tailiwind} alt="tailiwindCss" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={material} alt="materialUi" />
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.21 * 1000}>
          <img src={Ithish} alt="Vinayak Singh" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
